// extracted by mini-css-extract-plugin
export default {"SmallText":"ModelSwitcher-module__SmallText--fydkT","modelName":"ModelSwitcher-module__modelName--EXlIE"};